import { Link, IconButton } from '@material-ui/core';
import { IstanbulKartLogo, LoginIcon } from 'Components';
import { useLocalization, useLanguage } from 'Hooks';
import { useDispatch } from 'react-redux';
import { FunctionComponent, memo } from 'react';
import { setLanguage } from 'Stores/App';
import { WelcomeDrawer } from './WelcomeDrawer';
import { localStorageKeys, isLoginDisabled } from 'Config';
import { routePath } from 'Navigator/routes';
import { generateLanguageParam } from 'Utils';
import { onInıtDataRequest } from 'Stores/App';
import { push } from 'connected-react-router';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';
import { onGetFaqRequest } from 'Stores/Account';

import './WelcomeHeader.scss';

export type WelcomeHeaderMenuItemType = {
  title: string;
  onClick: () => void;
  Icon?: any;
  itemID: string;
  isActive?: boolean;
};

const WelcomeHeader = memo(() => {
  const dispatch = useDispatch();
  const {
    link_btn_language,
    web_footer_bize_ulasin,
    web_footer_sik_sorulan_sorular,
    web_link_btn_giris_yap,
  } = useLocalization();

  const i18n = useLanguage();

  const history = useHistory();

  const { pathname } = useLocation();

  const handleLanguageChange = () => {
    const language = localStorage.getItem(localStorageKeys.i18nextLng) === 'en' ? 'tr' : 'en';
    i18n.changeLanguage(language);
    dispatch(setLanguage());
    dispatch(onInıtDataRequest(generateLanguageParam()));
    dispatch(onGetFaqRequest());
  };

  const menuItems: WelcomeHeaderMenuItemType[] = [
    {
      title: link_btn_language,
      onClick: () => handleLanguageChange(),
      itemID: 'languageBtnTest',
    },
    {
      title: web_footer_bize_ulasin,
      onClick: () => history.push(routePath.welcomeContact),
      itemID: 'footerReactUsBtnTest',
      isActive: pathname === routePath.welcomeContact,
    },
    {
      title: web_footer_sik_sorulan_sorular,
      onClick: () => history.push(routePath.welcomeFaq),
      itemID: 'footerFaqBtnTest',
      isActive: pathname === routePath.welcomeFaq,
    },
    // Giriş kapalıyken (bkz. Config/FeatureFlags) "Giriş Yap" öğesi menüden
    // tamamen çıkarılır. Mobildeki drawer da bu diziyi kullandığı için orada da
    // görünmez.
    ...(isLoginDisabled
      ? []
      : [
          {
            title: web_link_btn_giris_yap,
            onClick: () => dispatch(push(routePath.login)),
            itemID: 'loginBtnTest',
          },
        ]),
  ];

  const handleLogoClick = () => {
    if (pathname === routePath.welcome) {
      window.location.reload();
    } else {
      history.push(routePath.welcome);
    }
  };

  return (
    <header id="headerWelcome">
      <IconButton
        aria-label="Ana sayfaya git"
        onClick={handleLogoClick}
        size="small"
        style={{ borderRadius: 4, padding: 4 }}
      >
        <IstanbulKartLogo width={220} />
      </IconButton>
      <WelcomeDrawer menuItems={menuItems} isDrawerLinks />
      <nav aria-label="Hoş geldiniz gezinim">
        <ul>
          {menuItems.map(({ title, onClick, itemID, isActive }, index) => (
            <MenuItem
              key={index}
              title={title}
              onClick={onClick}
              // Giriş ikonu öğenin KİMLİĞİNE bağlıdır, sıradaki yerine değil:
              // "son öğe" varsayımı, giriş öğesi menüden çıkarıldığında ikonu
              // yanlışlıkla SSS öğesine takıyordu.
              isLogin={itemID === 'loginBtnTest'}
              itemID={itemID}
              isActive={isActive}
            />
          ))}
        </ul>
      </nav>
    </header>
  );
});

const MenuItem: FunctionComponent<WelcomeHeaderMenuItemType & { isLogin: boolean }> = memo(
  ({ title, onClick, isLogin, itemID, isActive }) => {
    const handleKeyDown = (e: React.KeyboardEvent<HTMLAnchorElement>) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClick();
      }
    };

    return (
      <li>
        <Link
          underline="none"
          onClick={onClick}
          onKeyDown={handleKeyDown}
          itemID={itemID}
          tabIndex={0}
          role="link"
          className={isActive ? 'welcomeHeaderActiveItem' : ''}
          aria-current={isActive ? 'page' : undefined}
        >
          {title}
          {isLogin && <LoginIcon aria-hidden="true" />}
        </Link>
      </li>
    );
  }
);

export default WelcomeHeader;
